(function() {
  "use strict";

  angular.module("app.resources", ["ngRoute"]);
})();
